import { api } from 'lib/httpClient';

export const deleteFirm = (id) => {
  return () => {
    return api
      .delete(`firm/${id}`)
      .then((response) => {
        if (response.status === 200) {
          return Promise.resolve(response);
        }
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  };
};
